<template>
  <nav
    v-if="visibleNav"
    class="navbar navbar-expand-lg k-navbar bg-dark fixed-top"
  >
    <div @click="onHome" class="logo">
      <img
        class="logo-image"
        src="../../assets/logo_neu_weiss_blau_orange.png"
        alt=""
      />
    </div>

    <router-link
      v-if="0"
      class="text-nowrap ml-auto btn btn-primary btn-sm"
      active-class="active"
      data-toggle="collapse"
      data-target=".navbar-collapse.show"
      exact
      to="/pr/new"
      >{{ $t('header.newPoll') }}</router-link
    >

    <div v-if="auth" class="nav-items ml-auto headline-items align-items-center mr-3 p-1">
      <nav-user />
    </div>
    <component
      v-if="visibleDropdown"
      @close="onClose"
      :is="sidePanelDialog"
    ></component>
  </nav>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import EditProfile from '@/components/Edit/EditProfile.vue';
import NavUser from './NavUser.vue';

export default {
  name: 'Navigation',

  data() {
    return {
      visibleDropdown: false,
      sidePanelDialog: 'edit-profile',
      languages: [
        { flag: 'us', language: 'us', title: 'English' },
        { flag: 'de', language: 'de', title: 'German' },
      ],
    };
  },

  props: {
    locale: String,
  },

  components: {
    'edit-profile': EditProfile,
    NavUser,
  },

  computed: {
    ...mapState(['visibleNav']),

    auth() {
      return this.$store.getters.isAuthenticated;
    },

    showLogin() {
      return this.isAuthenticated === false;
    },
    ...mapGetters({
      isAuthenticated: 'isAuthenticated',
      userName: 'userName'
    }),

    flag() {
      for (var i in this.languages) {
        if (this.languages[i].language === this.locale) {
          let flag = this.languages[i].flag;
          return flag;
        }
      }
      return '';
    },

    language() {
      for (var i in this.languages) {
        if (this.languages[i].language === this.locale) {
          let title = this.languages[i].title;
          return title;
        }
      }
      return '';
    },
  },

  methods: {
    onHome() {
      console.log('Home was pressed');
      if (this.isAuthenticated) {
        console.log('go to dashboars');
        this.$router.push('/dashboard');
      } else {
        const homeUrl = process.env.VUE_APP_PUBLIC_HOME;
        console.log("Home url = ", homeUrl);
        window.location.href = homeUrl;
      }
    },

    changeLocale(locale) {
      console.log('Emit LOCALE event with value:' + locale);
      this.$emit('locale', locale);
    },

    onLogout() {
      this.$store.dispatch('logout');
    },

    onMyDashboard() {
      this.$router.push('dashboard');
    },

    onMyProfile() {
      //this.$router.push('profile');
      this.visibleDropdown = true;
    },

    onClose() {
      this.visibleDropdown = false;
    },
    onTest() {
      this.$router.push('profile');
    },

    onLogin() {
      this.$router.push({ path: '/login' });
    },

    activeClass2: function (...names) {
      for (let name of names) {
        if (name == this.$route.name) return 'active';
      }
    },

    activeClass: function (name) {
      if (name == this.$route.name) {
        return 'active';
      } else {
        return '';
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '@/styles/colors';

.navbar {
  padding: 0;
}

.nav-items {
  display: flex;
}

.nav-item {
  cursor: pointer;
}

.dropdown-toggle::after {
  display: none;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: '';
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}

.headline-items {
  display: flex;
  flex-direction: row;
}
</style>
